<template lang="pug">
	.auth(:class="state")
		.logo
		.auth-forms(v-if="Metadata.loaded")
			.login-area
				.login-content
					.title Login
					.buttons
						img.google-login(v-on:click="openGoogleLogin()" src="../../../public/Images/Screens/Login/sign-in-with-google.png")
</template>

<script>
	import Screen 							from './../../mixins/screen'
	import SetupSettings 					from "./../../settings/settings.json"

	import { Metadata } 					from './../../services/Metadata'
	import { User } 						from './../../services/User'

	export default {
		name: 'Auth',
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Metadata Loaded"]
		},
		data() {

			this.User = User;

			return {
				showed: true,
				state: '',
				companyName: ''
			}

		},
		methods: {
			collectData() {
				this.state = 'auth-only';
			},
			openGoogleLogin() {

				document.location = SetupSettings.loginUrlGoogle;

			}

		}
	}
</script>

<style lang="sass" scoped>

	.auth
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		background: center top / 100% auto no-repeat fixed
		background-size: cover
		min-height: 100vh

		.logo
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center
			height: 13vh
			width: 100%
			padding: 20px
			padding-bottom: 0

			.img
				height: 60%
				width: 90%
				background: url("../../../public/Images/Screens/Login/dashboard-logo.png") center / contain no-repeat
				image-rendering: -webkit-optimize-contrast

		.auth-forms
			display: flex
			flex-direction: row
			align-items: center
			justify-content: center
			width: 90vw
			max-width: 850px
			background-color: #24252f
			box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12), 0 1px 3px 0 rgba(0, 0, 0, .20)
			border-radius: 0.25rem
			margin: 20px
			overflow: hidden
			font-size: 0
			height: 260px
			transition: width 0.5s ease-in-out, max-width 0.5s ease-in-out

			.login-area
				width: 50%
				height: 100%
				color: rgba(255, 255, 255, 0.87)
				text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.27)
				font-weight: normal
				transition: width 0.5s ease-in-out, height 0.5s ease-in-out

				.login-content
					margin: 2.75rem
					width: 45vw
					max-width: calc(850px / 2 - 2.75rem * 2)

					.title
						font-size: 2.1875rem

					.description
						color: rgba(255, 255, 255, 0.6)
						font-size: 0.875rem

					.buttons
						display: flex
						flex-direction: row
						align-items: center
						justify-content: left
						margin-top: 1rem

						.linked-in-login
							display: flex
							height: 34px
							background-size: contain
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							margin-left: 10px
							image-rendering: -webkit-optimize-contrast

						.google-login
							display: flex
							height: 34px
							cursor: pointer
							filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))
							image-rendering: -webkit-optimize-contrast


	.auth.auth-only

		.auth-forms
			max-width: 450px
			transition: none

			.login-area
				width: 100%
				transition: none

			.signup-area
				display: none

</style>
